module.exports = __webpack_public_path__ + "img/8.a8ba7881.png";